import React from 'react';
import NavBar from '../../components/navbar/navBarComponent';
import Breadcrumb from '../../components/breadcrumb/breadcrumbComponent';
import MenuItem from '../../components/menu/menuItem';

const DiscountPage = (props) => {
  const breadcrumbItems = [
    { name: 'Menu', link: '/menu' },
    { name: 'Descuentos', link: '/discounts' },
  ];

  return (
    <div id="main-discount-menu" className="container-fluid page">
      <NavBar cart={props.cart} isLogIn={props.isLogIn} />
      <Breadcrumb page="discounts-admin" items={breadcrumbItems} />
      <div className="menu-container">
        <MenuItem
          title={'Nuevo Descuento'}
          text={'Crear Nuevo Descuento'}
          icon="local_offer"
          link="/discounts-create"
        />
        <MenuItem
          title={'Ver Descuentos'}
          text={'Ver Descuentos Creados'}
          icon="list"
          link="/discounts-list"
        />
      </div>
    </div>
  );
};

export default DiscountPage;